/**
 * 商品一覧表示用の共通ミックスイン
 * products.vueとworks.vueで共通使用される機能を提供
 */
import { processProductList } from '../utils/productSorting.js'

export const productListMixin = {
  data() {
    return {
      // 商品データ
      prdList: [],
      stkList: [],
      catList: [],
      catPrd: [],
      disList: [],
      
      // フィルター・ソート設定
      s_category: '0',
      s_sort: '0',
      s_stock: '0',
      
      // ページング設定
      perPage: 100,
      curPage: Number,
      minSlice: Number,
      num: Number,
      lastPage: Number,
      
      // UI状態
      fadeapp: false,
      isVisible: true,
      isFirst: false,
      isLast: false,
      isNotfound: false,
      
      // その他
      now: new Date()
    }
  },

  methods: {
    /**
     * フェードイン・アウト制御
     */
    fadeIn() {
      this.fadeapp = true
    },
    
    fadeOut() {
      this.fadeapp = false
    },

    /**
     * ページ移動処理
     */
    tagMove(to) {
      this.$router.push({'path': to.path, 'params': to.params})
      setTimeout(this.fadeIn, 300)
    },

    /**
     * カテゴリ・ソート・在庫設定の取得
     */
    getCategory() {
      if (this.query.opt !== void 0) {
        this.s_sort = this.query.opt
        this.$store.commit('CHANGE_SORT', this.s_sort)
      } else {
        this.s_sort = '0'
        this.$store.commit('CHANGE_SORT', this.s_sort)
      }

      if (this.query.cat !== void 0) {
        this.s_category = this.query.cat
      } else {
        this.s_category = '0'
      }

      if (this.query.stock !== void 0) {
        this.s_stock = this.query.stock
      } else {
        this.s_stock = '0'
      }
    },

    /**
     * 商品リストのソート・フィルタリング処理
     * 各コンポーネントでオーバーライド可能
     */
    sortList() {
      // 表示リストをクリア
      this.disList.splice(-this.disList.length)

      // ユーティリティ関数を使用してフィルタリング・ソート処理
      this.disList = processProductList({
        productList: this.prdList,
        keyword: this.getKeyword(),
        stockFilter: this.getStockFilter(),
        categoryFilter: this.s_category,
        sortType: this.s_sort,
        judgeStatus: this.judgeStatus.bind(this)
      })

      // 結果が空の場合の処理
      if (this.disList.length === 0) {
        this.isNotfound = true
      } else {
        this.isNotfound = false
      }

      // ストアの更新とページング処理
      this.$store.commit('CHANGE_SORT', this.s_sort)
      this.getPageCount()
      this.setPaging()
      this.fadeIn()
    },

    /**
     * キーワード取得（products.vueでオーバーライド）
     */
    getKeyword() {
      return null
    },

    /**
     * 在庫フィルター取得（デフォルト実装）
     */
    getStockFilter() {
      return this.s_stock
    },

    /**
     * ページング設定
     */
    setPaging() {
      this.num = this.$route.params['num']
      if (isNaN(this.num)) {
        this.num = this.$store.getters.get_pnum
      }
      if (this.num <= this.lastPage) {
        this.$store.commit('PAGE_MOVE', this.num)
        this.minSlice = (this.num - 1) * this.perPage
        this.curPage = this.num
      } else {
        this.minSlice = 0
        this.curPage = 1
        this.$store.commit('PAGE_MOVE', Number(this.curPage))
      }
    },

    /**
     * ページクリック処理
     */
    pageClick(page) {
      this.fadeOut()
      this.scrollToTop()
      
      if (page < this.curPage) {
        this.curPage = this.curPage - 1
        this.minSlice = (page - 1) * this.perPage
        this.curPage = Number(page)
        this.$store.commit('PAGE_MOVE', this.curPage)
        this.sendPageGA(page)
        this.tagMove({ path: this.getPagePath(page), params: {} })
      } else if (page > this.curPage) {
        this.curPage = this.curPage + 1
        this.minSlice = (page - 1) * this.perPage
        this.curPage = Number(page)
        this.$store.commit('PAGE_MOVE', this.curPage)
        this.sendPageGA(page)
        this.tagMove({ path: this.getPagePath(page), params: {} })
      }
    },

    /**
     * ページパス取得（各コンポーネントでオーバーライド）
     */
    getPagePath(page) {
      return `/products/${page}`
    },

    /**
     * ページGA送信（各コンポーネントでオーバーライド）
     */
    sendPageGA(page) {
      this.$gtag.query('config', 'UA-196118927-1', {
        'page_path': `/products/${page}`,
        'page_title': document.title
      })
      this.$gtag.query('config', 'G-S69VXZJE85', {
        'page_path': `/products/${page}`,
        'page_title': document.title
      })
    },

    /**
     * スクロール位置（各コンポーネントでオーバーライド）
     */
    scrollToTop() {
      scrollTo(0, 20)
    },

    /**
     * 前のページ
     */
    preClick() {
      if (!(Number(this.curPage) <= 1)) {
        this.pageClick(Number(Number(this.curPage)) - 1)
      }
    },

    /**
     * 次のページ
     */
    nextClick() {
      if (Number(this.curPage) !== this.lastPage) {
        this.pageClick(Number(Number(this.curPage)) + 1)
      }
    },

    /**
     * アクティブページ判定
     */
    activeNum(page) {
      if (Number(this.curPage) == 1) {
        this.isFirst = true
        this.isLast = false
      } else if (Number(this.curPage) == this.lastPage) {
        this.isLast = true
        this.isFirst = false
      } else {
        this.isFirst = false
        this.isLast = false
      }
      if (page == Number(this.curPage)) {
        return 'active'
      }
    },

    /**
     * ページ数計算
     */
    getPageCount() {
      this.lastPage = Math.ceil(this.disList.length / this.perPage)
      if (this.lastPage <= 1) {
        this.isVisible = false
      } else {
        this.isVisible = true
      }
    },

    /**
     * 画像設定
     */
    imageSet(image_obj) {
      if (image_obj[0] === void 0) {
        return '/images/nowprinting3.gif'
      } else {
        return image_obj[0].url
      }
    },

    /**
     * 価格設定
     */
    setPrice(v) {
      let price = v.map((n) => n.price)
      let highPrice = this.priceFilter(Math.max.apply(null, price))
      let rowPrice = this.priceFilter(Math.min.apply(null, price))
      if (highPrice == rowPrice) {
        return rowPrice
      } else {
        return rowPrice + '～' + highPrice
      }
    },

    /**
     * 在庫状況判定
     */
    judgeStatus(v, categories) {
      const release = new Date(v[0].releaseDate)
      let orderTo = new Date()
      if (v[0].reservationTo !== null) {
        orderTo = new Date(v[0].reservationTo)
      }
      const customStatus = categories.filter((v) => v.groupName == 'statusOption')

      const stockList = []
      v.forEach((variation) => {
        let varFil = this.stkList.filter((c) => c.productCode == variation.productCode)
        stockList.push(varFil)
      })
      let stockAvailable = 0
      stockList.forEach((s) => {
        if (s[0].available) {
          stockAvailable++
        }
      })

      if (this.now > orderTo) {
        return 'endofsale'
      } else if (stockAvailable == 0) {
        return 'soldout'
      } else if (this.now > release) {
        return 'exist'
      } else if (customStatus.length != 0) {
        return customStatus[0].name
      } else if (this.now < release) {
        return 'btoo'
      } else if (stockAvailable > 0) {
        return 'exist'
      } else {
        return 'soldout'
      }
    },

    /**
     * 価格フィルター
     */
    priceFilter(val) {
      if (!val) return ''
      return val.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    },

    /**
     * ページ移動処理（共通）
     */
    pagemove() {
      this.fadeOut()
      const url = this.getPagemoveUrl()
      this.$router.push(url)
      this.$store.commit('PAGE_MOVE', 1)
      this.curPage = 1
      this.scrollToTop()
      setTimeout(this.sortList, 300)
    },

    /**
     * ページ移動URL取得（各コンポーネントでオーバーライド）
     */
    getPagemoveUrl() {
      return `/products/1?cat=${this.s_category}&opt=${this.s_sort}&stock=${this.s_stock}`
    },

    /**
     * ローディング終了
     */
    endLoad() {
      this.$store.commit('DATA_LOAD', false)
    }
  }
}
